// Version : 0.0.1
// Author : AGALYA

const RecurringDepositProposalActionTypes = {
	/*************** START ADD RD PROPOSAL ***************/
	ADD_RD_PROPOSAL_START: 'ADD_RD_PROPOSAL_START',
	ADD_RD_PROPOSAL_SUCCESS: 'ADD_RD_PROPOSAL_SUCCESS',
	ADD_RD_PROPOSAL_FAILURE: 'ADD_RD_PROPOSAL_FAILURE',
	ADD_RD_PROPOSAL_RESPONSE_RESET: 'ADD_RD_PROPOSAL_RESPONSE_RESET',
	ADD_RD_PROPOSAL_RESPONSE_CHANGED: 'ADD_RD_PROPOSAL_RESPONSE_CHANGED',
	/*************** END ADD RD PROPOSAL ***************/

	/*************** START UPDATE RD PROPOSAL ***************/
	UPDATE_RD_PROPOSAL_START: 'UPDATE_RD_PROPOSAL_START',
	UPDATE_RD_PROPOSAL_SUCCESS: 'UPDATE_RD_PROPOSAL_SUCCESS',
	UPDATE_RD_PROPOSAL_FAILURE: 'UPDATE_RD_PROPOSAL_FAILURE',
	UPDATE_RD_PROPOSAL_RESPONSE_RESET: 'UPDATE_RD_PROPOSAL_RESPONSE_RESET',
	UPDATE_RD_PROPOSAL_RESPONSE_CHANGED: 'UPDATE_RD_PROPOSAL_RESPONSE_CHANGED',
	/*************** END UPDATE RD PROPOSAL ***************/

	/*************** START FETCH RD PROPOSAL ***************/
	FETCH_RD_PROPOSAL_START: 'FETCH_RD_PROPOSAL_START',
	FETCH_RD_PROPOSAL_SUCCESS: 'FETCH_RD_PROPOSAL_SUCCESS',
	FETCH_RD_PROPOSAL_FAILURE: 'FETCH_RD_PROPOSAL_FAILURE',
	FETCH_RD_PROPOSAL_RESPONSE_RESET: 'FETCH_RD_PROPOSAL_RESPONSE_RESET',
	FETCH_RD_PROPOSAL_RESPONSE_CHANGED: 'FETCH_RD_PROPOSAL_RESPONSE_CHANGED',
	/*************** END FETCH RD PROPOSAL ***************/

	/*************** START GET RD PROPOSAL ***************/
	GET_RD_PROPOSAL_START: 'GET_RD_PROPOSAL_START',
	GET_RD_PROPOSAL_SUCCESS: 'GET_RD_PROPOSAL_SUCCESS',
	GET_RD_PROPOSAL_FAILURE: 'GET_RD_PROPOSAL_FAILURE',
	GET_RD_PROPOSAL_RESPONSE_RESET: 'GET_RD_PROPOSAL_RESPONSE_RESET',
	GET_RD_PROPOSAL_RESPONSE_CHANGED: 'GET_RD_PROPOSAL_RESPONSE_CHANGED',
	/*************** END GET RD PROPOSAL ***************/

	/*************** START DELETE RD PROPOSAL ***************/
	DELETE_RD_PROPOSAL_START: 'DELETE_RD_PROPOSAL_START',
	DELETE_RD_PROPOSAL_SUCCESS: 'DELETE_RD_PROPOSAL_SUCCESS',
	DELETE_RD_PROPOSAL_FAILURE: 'DELETE_RD_PROPOSAL_FAILURE',
	DELETE_RD_PROPOSAL_RESPONSE_RESET: 'DELETE_RD_PROPOSAL_RESPONSE_RESET',
	DELETE_RD_PROPOSAL_RESPONSE_CHANGED: 'DELETE_RD_PROPOSAL_RESPONSE_CHANGED',
	/*************** END DELETE RD PROPOSAL ***************/
};
export default RecurringDepositProposalActionTypes;
